import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "api/baseurl";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// @mui material components
import Card from "@mui/material/Card";

// Custom components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";

// Authentication layout
import BasicLayout from "layouts/authentication/components/BasicLayout";

// Encryption utilities
import { encryptBody } from "encryptionAndDecryption/bodyEncryption";
import { decryptBody } from "encryptionAndDecryption/bodyDecryption";
import { fetchSecretKey } from "encryptionAndDecryption/secretKeyDecryption";

// Background Image
import bgImage from "assets/images/img.jpg";

function OTPVerification() {
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const userEmail = queryParams.get("email");
    if (userEmail) {
      setEmail(userEmail);
    }
  }, [location]);

  const handleChange = (e) => {
    setOtp(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!otp) {
      toast.error("Please enter the OTP!");
      return;
    }

    try {
      const secretKey = await fetchSecretKey();

      // Encrypt request body
      const encryptedData = encryptBody({ email, otp }, secretKey);
      console.log("Encrypted OTP Payload:", encryptedData);

      const response = await axios.post("/api/OTPVerification", encryptedData, {
        headers: {
          "Content-Type": "text/plain", // Match the encryption type
         
        },
      });

      if (response.status === 200) {
        const decryptedResponse = decryptBody(response.data, secretKey);
  
        if (!decryptedResponse) {
          throw new Error("Decryption failed, no data returned.");
        }
        if (decryptedResponse.success) { // ✅ Fixed condition
toast.success("OTP verified successfully. Please reset your password.");
          
  
          setTimeout(() => {
  navigate("/security", {
    state: {
      username: email, // or email
    },
  });
}, 100);
        } else {
          toast.error(decryptedResponse?.message || "Failed to verify registration.");
        }
      }
    } catch (error) {
      console.error("Registration Error:", error);
      toast.error(error.response?.data || "Registration failed");
    }
  };
  return (
<BasicLayout image="/loginimage.png">
      <Card>
      <MDBox pt={5} pb={3} px={3}>
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
           <img  src={process.env.REACT_APP_IMAGE_PATH} alt="logo" style={{ height: "60px" }} />

</div>
        </MDBox>
        <MDBox pt={4} pb={3} px={3}>
          <MDBox component="form" role="form" onSubmit={handleSubmit}>
            <MDBox mb={2}>
              <MDInput type="email" label="Email" fullWidth value={email} disabled />
            </MDBox>
            <MDBox mb={2}>
              <MDInput
                type="text"
                label="Enter OTP"
                fullWidth
                name="otp"
                value={otp}
                onChange={handleChange}
                required
              />
            </MDBox>
            {error && (
              <MDBox mt={2}>
                <MDTypography variant="caption" color="error">
                  {error}
                </MDTypography>
              </MDBox>
            )}
            <MDBox mb={2}>
  {/* Verify OTP Button */}
  <MDButton
    type="submit"
    variant="gradient"
    fullWidth
    sx={{
      background: "#1A237E",
      color: "#ffffff !important",
      fontWeight: "bold",
      py: 1.2,
      fontSize: "14px",
      borderRadius: "10px",
      "&:hover": {
        background: "#1A237E",
      },
    }}
  >
    Verify OTP
  </MDButton>
</MDBox>

<MDBox>
  {/* Back Button */}
  <MDButton
    type="button"
    variant="gradient"
    fullWidth
    onClick={() => navigate(-1)}
    sx={{
      background: "#1A237E",
      color: "#ffffff !important",
      fontWeight: "bold",
      py: 1.2,
      fontSize: "14px",
      borderRadius: "10px",
      "&:hover": {
        background: "#1A237E",
      },
    }}
  >
    Back
  </MDButton>
</MDBox>
          </MDBox>
        </MDBox>
      </Card>
    </BasicLayout>
  );
}

export default OTPVerification;
